import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
/*App imports*/
import { HelpersService } from '../../../services/tools/helpers.service';
import { PlazosService } from "../../../services/plazos.service";
import { CreditosService } from "../../../services/creditos.service";
import { ValidatorService } from '../../../services/tools/validator.service';
import { PrendariosService } from '../../../services/creditos/prendarios.service';
import { ConveniosService } from '../../../services/convenios.service';

@Component({
  selector: 'prendario-simulador',
  templateUrl: './prendario-simulador.component.html',
  styleUrls: ['./prendario-simulador.component.scss']
})

export class PrendarioSimuladorComponent implements OnInit {
  //Constants
  private tipoCredito = 3;
  //UI
  public cliente: any = {};
  public prestamo: any = {};
  public plazos: any = [];
  public plazoSelected: any = '';
  public catalogoPeriodicidad: any = {};
  public errors: any = {};
  //Subscriptions
  private sub: any;
  //Edit mode
  private id: number = null;
  //Selección de convenio
  public convenioDefault = "";
  public convenioSelected: any = { id: null };
  public optConvenios = []

  constructor(
    private helperService: HelpersService,
    private location: Location,
    private plazosService: PlazosService,
    private creditosService: CreditosService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private validatorService: ValidatorService,
    private prendariosService: PrendariosService,
    private conveniosService: ConveniosService
  ) {
  }

  public ngOnInit() {
    this.setDefaultValues();
    this.getConvenios();
    this.getPlazos();
    this.sub = this.activeRoute.params.subscribe(params => {
      if (params['id']) {
        //Edit mode
        this.id = params['id'] ? +params['id'] : 0; // (+) converts string 'id' to a number
        this.getCredito(this.id);
      }
    });
  }

  private setDefaultValues() {
    this.prestamo.calculo = 2;//Calculo crédito simple
    this.prestamo.periodicidad = 2;//Periodicidad Mensual
    this.prestamo.idConvenio = null;//Periodicidad Mensual
    this.catalogoPeriodicidad = this.creditosService.getCatalogoPeriodicidad();
  }

  public getConvenios() {
    // let filters = this.getActiveFilters();

    this.conveniosService.getAll({ tipo: "Prendario" }).subscribe(
      (response) => {
        let respuesta = response.json().content;
        console.log(respuesta);
        if (respuesta.length > 1) {
          this.optConvenios = respuesta;
          this.convenioDefault = "Sin convenio";
        } else {
          this.optConvenios = respuesta;
          this.convenioDefault = "Sin convenio";
          // Descomentar si es obligatoria el convenio
          // this.convenioSelected = this.optConvenios[0];
          // this.prestamo.idConvenio = this.convenioSelected.id;
          // this.prestamo.periodicidad = this.convenioSelected.periodicidad;
        }
      }, error => {
      // se resuelve error 403 y 500
      this.helperService.httpGlobalError(error);

      if (error.status == 400) {
        this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
      }
    }
    );
  }

  convenioChanged(tipo) {
    console.log("Event convenio: ", tipo);

    if (tipo.id) {
      this.convenioSelected = tipo;
      this.prestamo.periodicidad = this.convenioSelected.periodicidad;
      this.prestamo.idConvenio = this.convenioSelected.id;

    } else {
      this.setDefaultValues();
    }
  }
  private selectConvenio(tipo) {
    this.convenioSelected = this.optConvenios[0];
    // this.convenio.tipo_convenio = this.tipoSelected;
    for (let index = 0; index < this.optConvenios.length; index++) {
      const element = this.optConvenios[index];
      if (element.nombre === tipo) {
        this.convenioSelected = this.optConvenios[index];
        // this.convenio.tipo_convenio = tipo;
        break;
      }

    }
  }

  private getCredito(idCredito) {

    //TODO: Manejar cuando el id no retorna un crédito valido
    this.creditosService.get(idCredito).subscribe(
      (response) => {
        const result = response.json().content;
        console.log(result);
        this.prestamo = result.prestamo;
        this.cliente = result.cliente;
        this.selectConvenio(result.idConvenio);
        this.selectPlazo(result.prestamo);
      }, error => {
      // se resuelve error 403 y 500
      this.helperService.httpGlobalError(error);

      if (error.status == 400) {
        this.setBackendErrors(error.json().content);
        this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
      }
    }
    );
  }

  public save() {
    this.errors = {};

    let credito = {
      idCreditos: null,
      prestamo: this.prestamo,
      cliente: null
    };

    if (typeof this.cliente.email === 'object') {
      //Cuando se selecciono un usuario con Typeahead, 
      //el modelo cliente.email tiene asociado un objeto con todos los datos del cliente
      let clienteToSave = {
        email: this.cliente.email.email,
        nombre: this.cliente.nombre,
        telefono: this.cliente.telefono,
        estado: this.cliente.estado,
        //Cuando es un update el modelo this.cliente tiene todos los datos del cliente
        //En el caso del create en el modelo this.cliente.email Typeahead pone el JSON completo del Cliente
        id: (this.cliente.id ? this.cliente.id : this.cliente.email.id)
      };
      credito.cliente = clienteToSave;
    } else {
      //Caso cuando el email se ingreso de forma manual
      credito.cliente = this.cliente;
    }

    //El plazo seleccionado esta en el modelo plazoSelected, se debe actualizar el valor en el modelo que se enviará al servicio
    if (this.plazoSelected) {
      //Default solo para pruebas
      credito.prestamo.plazo_periodo = this.plazoSelected.periodo;
      credito.prestamo.plazo_medida = this.plazoSelected.medida;
    }

    this.errors = this.prendariosService.validate(credito);
    if (Object.entries(this.errors).length > 0) {
      return false;
    }

    if (this.id) {
      //Update credito
      //set idCreditos
      credito.idCreditos = this.id;
      this.update(credito);
    } else {
      //New credito
      console.log(credito);
      this.create(credito);
    }
  }

  private create(credito: any) {
    this.prendariosService.save(credito).subscribe(
      (response) => {
        const result = response.json().content;
        //Navigate to tabla de amortizacion
        this.router.navigate(['/creditos/tabla-amortizacion/', result.id]);
      }, error => {
      // se resuelve error 403 y 500
      this.helperService.httpGlobalError(error);

      if (error.status == 400) {
        this.showSaveCreditErrors(error.json().content);
      }
    }
    );
  }

  private update(credito) {
    this.prendariosService.update(credito).subscribe(
      (response) => {
        const result = response.json().content;
        //Navigate to tabla de amortizacion
        this.router.navigate(['/creditos/tabla-amortizacion/', this.id]);
      }, error => {
      // se resuelve error 403 y 500
      this.helperService.httpGlobalError(error);

      if (error.status == 400) {
        this.showSaveCreditErrors(error.json().content)
      }
    }
    );
  }

  public goBack() {
    this.location.back();
  }

  /**
   * Helpers
   */
  private getPlazos() {
    this.plazosService.getAll(this.tipoCredito).subscribe(
      (response) => {
        this.plazos = response.json().content;
      }, error => {
      // se resuelve error 403 y 500
      this.helperService.httpGlobalError(error);

      if (error.status == 400) {
        this.setBackendErrors(error.json().content);
        this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
      }
    }
    );
  }

  private selectPlazo(prestamo: any) {
    let selectedPlazo = null;
    this.plazos.forEach(function (element) {

      if (prestamo.plazo_periodo === element.periodo && prestamo.plazo_medida === element.medida) {
        selectedPlazo = element;
      }
    });

    if (selectedPlazo) {
      this.plazoSelected = selectedPlazo;
    }
  }

  private setBackendErrors(errors: any[]) {
    let temp_errors = [];

    Object.keys(errors).forEach(function (key) {
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }

  private showSaveCreditErrors(errors) {
    let temp_errors = [];

    Object.keys(errors).forEach(function (key) {
      //temp_errors.push()

      //TODO: Agregar el mapeo de todos los posibles errores en el backend
      switch (key) {
        case 'cliente.email':
          temp_errors['email'] = errors[key][0];
          break;
      }
    });

    this.errors = temp_errors;
  }
}


// WEBPACK FOOTER //
// ./src/app/creditos/prendario/simulador/prendario-simulador.component.ts